/**
 * Created by olga on 24.12.2025
 */

Object.assign(AdsLimits.TYPES, {
    THIRD_ELEMENT_CREATE: "third_element_create",
    SPEEDUP: "speedup",

    REFRESH_SHOP_PB: "refresh_shop_pb",
    SHOP_BOOSTER: "shop_booster"
});

AdsLimits.THRESHOLDS = {
    undecided: { level: 7, android: { level: 8 } },
    nonpayer7: { level: 13, android: { level: 14 } },
    nonpayer13: { level: 20, android: { level: 21 } },
    nonpayer20: {}
};
